/* Keep slideshow media inside the section-pinned aspect box.
   Do NOT rewrite container aspect-ratio per image — that caused mobile
   hero height jumps (landscape video ~158px vs portrait slides) and grey
   peek gaps. Section CSS in blocks/slide.liquid owns the ratio. */
(function () {
  if (window.__ashSlideAspectInit) return;
  window.__ashSlideAspectInit = true;

  function fixOne(img) {
    if (!img) return;
    var apply = function () {
      if (img.hasAttribute('width')) img.removeAttribute('width');
      if (img.hasAttribute('height')) img.removeAttribute('height');

      var slide = img.closest('slideshow-slide');
      if (slide) {
        // Slideshow: only ensure cover fill; never override aspect-ratio.
        img.style.setProperty('width', '100%', 'important');
        img.style.setProperty('height', '100%', 'important');
        img.style.setProperty('object-fit', 'cover', 'important');
        img.style.setProperty('object-position', 'center center', 'important');
        img.style.setProperty('max-height', 'none', 'important');
        return;
      }

      // Non-slideshow images: natural ratio (legacy path).
      var w = img.naturalWidth;
      var h = img.naturalHeight;
      if (!w || !h) return;
      var ratio = w + ' / ' + h;
      var c = img.closest('.slide__image-container');
      if (c) {
        c.style.setProperty('aspect-ratio', ratio, 'important');
        c.style.setProperty('height', 'auto', 'important');
        c.style.setProperty('max-height', 'none', 'important');
        c.style.setProperty('min-height', '0', 'important');
        c.style.setProperty('position', 'relative', 'important');
      }
      img.style.setProperty('aspect-ratio', ratio, 'important');
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('height', 'auto', 'important');
      img.style.setProperty('max-height', 'none', 'important');
      img.style.setProperty('min-height', '0', 'important');
      img.style.setProperty('object-fit', 'initial', 'important');
    };
    if (img.complete && img.naturalWidth) {
      apply();
    } else {
      img.addEventListener('load', apply, { once: true });
    }
  }

  function fixAll(root) {
    (root || document).querySelectorAll('slideshow-slide .slide__image').forEach(fixOne);
  }

  function runAndRetry() {
    fixAll();
    [50, 250, 750, 1500, 3000].forEach(function (delay) {
      setTimeout(function () {
        fixAll();
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAndRetry);
  } else {
    runAndRetry();
  }
  window.addEventListener('load', function () {
    fixAll();
  });
  window.addEventListener(
    'resize',
    function () {
      fixAll();
    },
    { passive: true }
  );

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      if (!added) continue;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (
          n.nodeType === 1 &&
          ((n.matches && n.matches('slideshow-slide .slide__image')) ||
            (n.querySelector && n.querySelector('slideshow-slide .slide__image')))
        ) {
          fixAll(n.parentNode || document);
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
